import { Modal, Group, Button, Text } from '@mantine/core';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';
import { deleteHelpdeskEntity } from '../../../../libraries/helpdesk/entities';
import { StatusType } from '../../../../libraries/zps';
import { useStatusOperDialog } from '../../../context/status-oper-dialog';

interface DeleteHeldeskEntityProps {
  entity: number;
  onReload: () => void;
}

const DeleteHeldeskEntity = ({ entity, onReload }: DeleteHeldeskEntityProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { handleApiError, showStatusOperDialog } = useStatusOperDialog();

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const deleteEntity = async () => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const response = await deleteHelpdeskEntity(Number(entity), controller);
      const statusOper = response.data?.statusOper;

      if (!statusOper || statusOper.code !== 0) {
        showStatusOperDialog({
          type: StatusType.ERROR,
          message: lang.EDIT_ENTITY_CONTROLLER_ALERT_DELETE_ERROR,
          statusOper
        });
        return;
      }

      showStatusOperDialog({
        type: StatusType.INFO,
        message: lang.EDIT_EQUIPMENTS_ALERT_UPDATED_SUCCESS,
        statusOper: response.data?.statusOper
      });

      setShowModal(false);
      onReload();
    } catch (error: any) {
      if (error.name === 'CanceledError' || error.name === 'AbortError') return;

      handleApiError(error, lang.EDIT_ENTITY_CONTROLLER_ALERT_DELETE_ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button radius="md" onClick={openModal} color="#861724">
        {lang.GLOBAL_DELETE}
      </Button>

      <Modal opened={showModal} onClose={closeModal} centered withCloseButton={false}>
        <Text>{lang.HELPDESK_ENTITY_REMOVE}</Text>

        <Group style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button radius="md" onClick={deleteEntity} loading={loading}>
            {lang.YES}
          </Button>

          <Button radius="md" onClick={closeModal} style={{ marginRight: '0.5rem' }}>
            {lang.NO}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default DeleteHeldeskEntity;
